<script>
// Stock column of the catalogue grids (catalogue, Équivalents, kits) — one source of truth, also used by the
// phone line under the designation (VUE_APP_FEATURE_MOBILE_CATALOG). Root is a v-if chain: exactly one
// element renders, the same DOM as the former inline cell.
export default {
  name: 'CatalogStockStatus',
  props: {
    item: { type: Object, required: true },
    // loose == comparisons below, as in the former inline cell: a string status still matches
    value: { type: [Number, String], default: null },
  },
  methods: {
    getRemainingQuantityInControlledSaled(maxPerDay, alreadyOrderedPerDay) {
      const remainingQuantity = maxPerDay - alreadyOrderedPerDay;
      return remainingQuantity < 0 ? 0 : remainingQuantity;
    },
  },
};
</script>

<template>
  <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
  <div v-else-if="value==3"  class="font-size-18"> _</div>
  <i v-else-if="value==0 || value== 7" :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
  <i v-else-if="value==1" :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
  <div v-else-if="value==4" title="Vente controllée" class="text-info font-weight-bold font-size-14">
    <span :class="item.alreadyOrderedPerDay ? 'strikethrough text-muted mr-1' : ''">{{ item.maxPerDay }} </span>
    <span v-if="item.alreadyOrderedPerDay">{{ getRemainingQuantityInControlledSaled(item.maxPerDay, item.alreadyOrderedPerDay) }}</span> {{ '/' + ((item.salesControlDayCount && item.salesControlDayCount > 1) ? item.salesControlDayCount : '') + 'J' }}</div>
  <div v-else-if="value == 5" class="d-flex align-items-center justify-content-center">
    <span style="border-radius: 5px;" title="Article en répartition"
      class="text-primary p-1 font-weight-bold font-size-16 d-flex align-items-center justify-content-center text-center"
      >{{ item.repartitionQuantity }}</span>
  </div>
  <div v-else-if="value == 6" class="d-flex align-items-center justify-content-center" title="Il est actuellement impossible de commander les articles en répartition via la plateforme. Nous vous invitons à passer votre commande par téléphone.">
    <i class="fas fa-phone font-size-20 text-danger"></i>
  </div>
</template>
